import React, { useEffect, useState } from 'react'
import { Grid, Box } from '@mui/material'
import { Fade } from 'react-slideshow-image'
import 'react-slideshow-image/dist/styles.css'
import config from '../config'
import axios from 'axios'
import './Slides.css'
export default function Slideshow() {
  const [dataBanner, setDataBanner] = useState([])

  useEffect(() => {
    axios
      .get(`${config.url}/banners`, config.token)
      .then((res) => {
        setDataBanner(res.data.data)
      })
      .catch((e) => console.log(e))
  }, [])

  const properties = {
    duration: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    indicators: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  }

  return (
    <Grid container>
      <Grid item xs={12} sm={12}>
        <Box
          sx={{
            width: 'auto',
            height: {
              lg: '60vh',
              xs: '18vh',
            },
            borderRadius: {
              xs: 5,
              lg: 10,
            },
            m: '20px',
            overflow: 'hidden',
          }}
        >
          <Fade {...properties}>
            {dataBanner.map((img, index) => (
              <div className='each-slide' key={index}>
                <Box
                  component='img'
                  src={img?.image_full_path}
                  style={{
                    objectFit: {
                      xs: 'fill',
                      lg: 'cover',
                    },
                    // minHeight: {
                    //   xs: '400px',
                    //   lg: 600,
                    // },
                    // height: {
                    //   lg: '50vh',
                    //   xs: '20vh',
                    // },
                    height: '100%',
                    width: '100%',
                  }}
                />
              </div>
            ))}
          </Fade>
        </Box>
      </Grid>
    </Grid>
  )
}
